import { createAggregateRow } from '../create-aggregate-row/create-aggregate-row';
import { CreateAggregateRowsInput, EventHoursRow } from '../interfaces';

export const createAggregateRows = (params: CreateAggregateRowsInput): EventHoursRow[] => {
  const { rowsWithAllDataUser, months } = params;

  const allRows = rowsWithAllDataUser.map((item) => item.row);

  const adminRows = rowsWithAllDataUser
    .filter((item) => item.allDataUser !== undefined && item.allDataUser.roles.isOrgAdmin())
    .map((item) => item.row);

  const notAdminRows = rowsWithAllDataUser
    .filter((item) => item.allDataUser !== undefined && !item.allDataUser.roles.isOrgAdmin())
    .map((item) => item.row);

  return [
    createAggregateRow({
      id: 'total-for-org',
      displayName: 'Total for Org (includes deleted users)',
      rows: allRows,
      months,
    }),
    createAggregateRow({
      id: 'total-for-org-admin',
      displayName: 'Total for Org Admin (excludes deleted users)',
      rows: adminRows,
      months,
    }),
    createAggregateRow({
      id: 'total-for-not-org-admin',
      displayName: 'Total for Not Org Admin (excludes deleted users)',
      rows: notAdminRows,
      months,
    }),
  ];
};
